
export const thumbnailCharacter = (characterThumbnailString: string) => {
	if (characterThumbnailString == null || characterThumbnailString.includes("render")) {
		return characterThumbnailString;
	}
	else {
		return "https://render-eu.worldofwarcraft.com/character/" + characterThumbnailString;
	}

};
export const thumbnailClass = (classId: number) => {
	return "/images/warcraft/classes/class_" + classId + ".jpg";
};
export const iconRole = (roleString: string) => {
	return "/images/warcraft/icon-" + (roleString ? roleString.toLowerCase() : "") + ".png";
};
export const iconFaction = (sideInt: string) => {
	return "/images/warcraft/faction-" + sideInt + ".png";
};
export const iconBuff = (icon: string) => {
	return "/images/warcraft/buffs/" + icon;
};
export const thumbnailBoss = (bossUrlSlug: string) => {
	return "https://wow.zamimg.com/images/wow/journal/ui-ej-boss-" + bossUrlSlug + ".png";
};
export const iconItem = (icon: string) => {
	return `https://wow.zamimg.com/images/wow/icons/large/${icon}.jpg`;
};
export const largeThumbnailZone = (zoneId: number) => {
	return "/images/zones/large/" + zoneId + ".png";
};
export const thumbnailZone = (zoneId: number) => {
	return "/images/zones/medium/" + zoneId + ".png";
};
export const miniThumbnailZone = (zoneId: number) => {
	return "/images/zones/mini/" + zoneId + ".png";
};
export const wideThumbnailZone = (zoneId: number) => {
	return "/images/zones/wide/" + zoneId + ".png";
};

export const discordAvatar = (discordId: string, discordAvatar: string) => {
	if (discordAvatar == null) {
		return "https://cdn.discordapp.com/embed/avatars/0.png";
	}
	else {
		return `https://cdn.discordapp.com/avatars/${discordId}/${discordAvatar}.png`;
	}
};